export class DifferencePeriode {
	differenceNombreSemaines: number;
	differenceNombreJours: number | null;

	constructor(differenceNombreSemaines: number, differenceNombreJours: number | null) {
		this.differenceNombreSemaines = differenceNombreSemaines;
		this.differenceNombreJours = differenceNombreJours;
	}
}